<template>
  <div>
    <RoutingPlanTabHeader
      v-model="filters.name.value"
      :is-refreshing="vm.isRefreshingTargetGroups"
      @refresh="vm.refreshTargetGroups"
      @create-new="vm.openNewTargetGroupModal"
    />

    <div
      v-if="vm.targetGroups.length"
      class="grid_table_holder p-10"
    >
      <v-table
        :data="vm.targetGroups"
        :current-page.sync="currentPage"
        :page-size="10"
        :filters="filters"
        class="table_beauty table-condensed"
        cellpadding="0"
        cellspacing="0"
        @totalPagesChanged="totalPages = $event"
      >
        <thead slot="head">
          <tr>
            <v-th
              v-t="'CAMPAIGN_STEP_ROUTING_GROUPS_NAME'"
              class="column-sortable width-30-percent"
              sort-key="name"
              align="left"
              default-sort="asc"
            />
            <v-th
              v-t="'CAMPAIGN_STEP_ROUTING_GROUPS_SIMULDIAL'"
              sort-key="isSimalDial"
              align="center"
              class="column-sortable"
            />
            <v-th
              v-t="'CAMPAIGN_STEP_ROUTING_GROUPS_TARGETS'"
              sort-key="targets"
              align="center"
              class="column-sortable"
            />
            <v-th
              v-t="'CAMPAIGN_STEP_ROUTING_GROUPS_STATUS'"
              sort-key="enabled"
              align="center"
              class="column-sortable"
            />
            <th
              v-t="'CAMPAIGN_STEP_ROUTING_GROUPS_ADD'"
              align="center"
            />
          </tr>
        </thead>

        <tbody
          slot="body"
          slot-scope="{ displayData }"
        >
          <tr
            v-for="group in displayData"
            :key="group.id"
            class="border_bottom"
          >
            <td align="left">
              <LinkedName
                :href="getHref('dashboard.targetgroup.edit', { targetGroupId: group.id, name: group.name })"
                :title="group.name"
              />
            </td>

            <td align="center">
              <i
                :class="group.isSimalDial ? 'true typcn typcn-tick' : 'false typcn typcn-times'"
              />
            </td>
            <td align="center">
              {{ group.targets.length || 0 }}
            </td>
            <td align="center">
              <span
                v-if="!group.enabled"
                v-tooltip.right.hover="$t('TARGETS_STATUS_DISABLED_GROUP')"
                class="red_status"
              />
              <span
                v-else
                v-tooltip.right.hover="$t('TARGETS_STATUS_OPEN')"
                class="green_status"
              />
            </td>
            <td align="left">
              <a
                class="btn btn-list-function typcn typcn-arrow-right-thick"
                @click="vm.openNewTargetGroupRouteModal(group)"
              />
            </td>
          </tr>
        </tbody>
      </v-table>
      <div class="pagination-min">
        <div class="text-center p-0">
          <smart-pagination
            :current-page.sync="currentPage"
            :total-pages="totalPages"
            :max-page-links="5"
          />
        </div>
      </div>
    </div><!--ending of grid_table_holder-->

    <LoadingStatusDisplay
      v-if="vm.isLoading"
      :loading="true"
    >
      {{ $t('CAMPAIGN_STEP_ROUTING_LOADING_TARGET_GROUPS') }}
    </LoadingStatusDisplay>
    <div
      v-else-if="!vm.targetGroups.length"
      class="col-xs-12"
    >
      {{ noTargetAvailableMessage }}
    </div>

    <template
      v-if="vm.modal != null"
    >
      <div
        v-if="vm.modal.type === 'new-target-group'"
        @click="vm.closeModal()"
      >
        TODO: New Target Group Modal (click to close)
        <br>
        templateUrl: 'scripts/shared/components/select-target/new-target-group.modal.html'
      </div>
      <div
        v-else-if="vm.modal.type === 'new-target-group-route'"
        @click="vm.closeModal()"
      >
        TODO: New Target Route  Modal (click to close)
        <br>
        templateUrl: 'scripts/shared/components/select-target/new-target-group-route.modal.html'
        <br>
        {{ vm.modal.target.name }}
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, reactive } from 'vue';
import { AvailableTargetGroupsViewModel } from '../models/AvailableTargetGroupsViewModel.js';
import LinkedName from '@/core/components/LinkedName/LinkedName.vue';
import RoutingPlanTabHeader from './RoutingPlanTabHeader.vue';
import LoadingStatusDisplay from '@/core/components/Loader/LoadingStatusDisplay.vue';
import sharedMessages from '@/core/locales';
import messages from '../locales';

import {
  $ngStateService,
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default defineComponent({
  name: 'AvailableTargetGroups',
  components: {
    RoutingPlanTabHeader,
    LinkedName,
    LoadingStatusDisplay,
  },
  inject: {
    context: {
      from: 'routingPlansContext',
    },
  },
  data() {
    return {
      vm: reactive(new AvailableTargetGroupsViewModel()),
      currentPage: 1,
      totalPages: 0,
      filters: {
        name: {
          value: '',
          keys: ['number', 'phoneNumber', 'displayNumber', 'name', 'campaignName', 'publisherName'],
        },
      },
    };
  },
  computed: {
    noTargetAvailableMessage() {
      if (this.vm.hasAnyGroup) {
        return this.$t('CAMPAIGN_STEP_ROUTING_ALL_TARGET_GROUPS_ASSIGNED');
      }

      return this.$t('CAMPAIGN_STEP_ROUTING_NONE_TARGET_GROUPS');
    },
  },
  methods: {
    getHref(state, params) {
      return $ngStateService.href(
        state,
        params,
        { absolute: true }
      );
    },
  },
  mounted() {
    this.vm.initialize(this.context);
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
});

</script>
